// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__6R8tH","content":"Banner_content__gI4FC","brand":"Banner_brand__GNcwx","slogan":"Banner_slogan__tRsMP","btnWrapper":"Banner_btnWrapper__nHZap"};